import { ObjectSchema } from 'yup';
import { useFormik } from 'formik';

export type UseFormProps<T> = {
  initialValues: any;
  onSubmit: (values: T) => void;
  validationSchema?: ObjectSchema<any>;
};
export function useForm<T>({
  initialValues,
  onSubmit,
  validationSchema,
}: UseFormProps<T>) {
  const {
    values,
    handleSubmit,
    handleChange,
    errors,
    touched,
    handleBlur,
    isValid,
    setFieldValue,
    setFieldTouched,
    validateField,
    setFieldError,
    isSubmitting,
    resetForm,
    setValues,
    // [AJUSTE 07/08/2026] exposto para a tela conseguir dizer POR QUE nao salvou.
    // O Formik simplesmente nao chama o onSubmit quando a validacao reprova; sem
    // acesso aos erros, o clique no Salvar fica sem resposta nenhuma.
    validateForm,
  } = useFormik({
    initialValues,
    // @ts-ignore - .
    onSubmit,
    validateOnMount: false,
    enableReinitialize: true,
    validationSchema,
    validateOnBlur: true,
    validateOnChange: false,
  });

  const handleSelectChange = (name: string, value: any) => {
    setFieldValue(name, value, true);
  };

  const handleRadioChange = (name: string, value: any) => {
    setFieldValue(name, value, true);
  };

  const handleTextChange = (name: string, value: any) => {
    setFieldValue(name, value, false);
  };

  const handleAreaBoxChange = (name: string, value: any) => {
    setFieldValue(name, value, true);
  };

  const handleSelectBlur = (name: string) => {
    setFieldTouched(name);
  };

  const handleAreaBoxBlur = (name: string) => {
    setFieldTouched(name);
  };

  const handleCheckBoxBlur = (name: string) => {
    setFieldTouched(name);
  };

  const handleRadioBlur = (name: string) => {
    setFieldTouched(name);
  };

  return {
    handleRadioChange,
    handleSelectBlur,
    handleSelectChange,
    handleAreaBoxChange,
    handleAreaBoxBlur,
    handleCheckBoxBlur,
    handleRadioBlur,
    handleSubmit,
    validateField,
    setFieldError,
    values,
    handleChange,
    errors,
    touched,
    handleBlur,
    isValid,
    setFieldValue,
    setFieldTouched,
    isSubmitting,
    handleTextChange,
    resetForm,
    setValues,
    validateForm,
  };
}
